import React from 'react';
import PropTypes from 'prop-types';
import QAItem from '../QAItem';
import useSearchMatches from '../../hooks/useSearchMatches';
import { QuestionsContainer, NoResults } from './styled';

const Questions = ({ className, questions }) => {
  const { isSearchMatch } = useSearchMatches(questions);

  return (
    <QuestionsContainer className={className} data-id="term-definition-container">
      {isSearchMatch ? (
        questions.map((item, i) => (
          <QAItem
            key={i}
            id={`question-${item.sys?.id}`}
            question={item.fields.question}
            answer={item.fields.answer}
            sections={item.fields?.sections}
            isOpen
          />
        ))
      ) : (
        <NoResults>No results found</NoResults>
      )}
    </QuestionsContainer>
  );
};

Questions.propTypes = {
  className: PropTypes.string,
  questions: PropTypes.array
};

export default Questions;
